var map = {
	"./chest-immortal.svg": "b68b",
	"./chest.svg": "c404",
	"./coin-001.svg": "65ec",
	"./coin-002.svg": "b46d",
	"./coin-003.svg": "531f",
	"./coin-004.svg": "041f",
	"./coin-005.svg": "5e9e",
	"./coin-006.svg": "6d02",
	"./coin-007.svg": "0b5c",
	"./exclamation-mark.png": "a315",
	"./hint.svg": "2f60",
	"./icon-coupon.svg": "a7c4",
	"./internet.png": "4a56",
	"./open.svg": "a6bb",
	"./rewind.svg": "83cf",
	"./skip.svg": "149b",
	"./ticket-001.svg": "f095",
	"./ticket-002.svg": "1ab1",
	"./ticket-003.svg": "189c",
	"./ticket-004.svg": "4861",
	"./ticket-005.svg": "d2e3",
	"./ticket-immortal.svg": "7ef8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4819";